import feldUtils from "@/businesslogic/utils/feldUtils";
import Logger from "js-logger";
import AdressenDatenService from "@/businesslogic/services/AdressenDatenService";
import dateUtils from "@/businesslogic/utils/dateUtils";

export default function validatoren(): any {
  const { istInt, stringZuInt } = feldUtils();
  const { getIsoDateNow, dateStringToIsoDate, getAlterZuStichtag, dateStringToLocalDate } = dateUtils();

  function checkMinMaxWert(
    feldName: string,
    feldWert: string,
    minWert: string,
    maxWert: string,
    required: boolean,
  ): string | undefined {
    Logger.trace(
      "checkMinMaxWert",
      "feldName: " + feldName,
      "feldWert: " + feldWert,
      "minWert: " + minWert,
      "maxWert: " + maxWert,
      "required: " + required,
    );

    let fehlermeldung = undefined;

    if (feldWert == "" && required) {
      return "Bitte geben Sie einen Wert ein.";
    } else if (feldWert && !istInt(feldWert)) {
      return "Bitte geben Sie einen numerischen Wert ohne Dezimal- und Tausendertrennzeichen ein.";
    } else if (feldWert) {
      const feldWertInt = stringZuInt(feldWert);
      const minWertInt = stringZuInt(minWert);
      const maxWertInt = stringZuInt(maxWert);
      if (minWertInt && maxWertInt && (feldWertInt < minWertInt || feldWertInt > maxWertInt)) {
        fehlermeldung = "Bitte geben Sie einen Wert zwischen " + minWertInt + " und " + maxWertInt + " ein.";
      } else if (minWertInt && feldWertInt < minWertInt) {
        fehlermeldung = "Bitte geben Sie einen Wert von mindestens " + minWertInt + " ein.";
      } else if (maxWertInt && feldWertInt > maxWertInt) {
        fehlermeldung = "Bitte geben Sie einen Wert von maximal " + maxWertInt + " ein.";
      }
    }
    if (fehlermeldung) {
      Logger.trace("     -> " + fehlermeldung);
    }
    return fehlermeldung;
  }

  function checkMinMaxLaenge(
    feldName: string,
    feldWert: string,
    minLaenge: string,
    maxLaenge: string,
    required: boolean,
  ): string | undefined {
    Logger.trace(
      "checkMinmaxLaenge",
      "feldName: " + feldName,
      "feldWert: " + feldWert,
      "minLaenge: " + minLaenge,
      "maxLaenge: " + maxLaenge,
      "required: " + required,
    );

    let fehlermeldung = undefined;

    if (feldWert == "" && required) {
      fehlermeldung = "Bitte geben Sie einen Wert ein.";
    } else if (feldWert) {
      const feldLaengeInt = feldWert.trim().length;
      const minLaengeInt = stringZuInt(minLaenge);
      const maxLaengeInt = stringZuInt(maxLaenge);
      if (minLaengeInt > 0 && maxLaengeInt > 0 && (feldLaengeInt < minLaengeInt || feldLaengeInt > maxLaengeInt)) {
        fehlermeldung =
          "Bitte geben Sie einen Text zwischen " + minLaengeInt + " und " + maxLaengeInt + " Zeichen ein.";
      } else if (minLaengeInt > 0 && feldLaengeInt < minLaengeInt) {
        fehlermeldung = "Bitte geben Sie einen Text von mindestens " + minLaengeInt + " Zeichen ein.";
      } else if (maxLaengeInt > 0 && feldLaengeInt > maxLaengeInt) {
        fehlermeldung = "Bitte geben Sie einen Text von maximal " + maxLaengeInt + " Zeichen ein.";
      }
    }
    if (fehlermeldung) {
      Logger.trace("     -> " + fehlermeldung);
    }
    return fehlermeldung;
  }

  function checkMinMaxDatum(
    feldName: string,
    feldWert: string,
    minDatum: string,
    maxDatum: string,
    required: boolean,
  ): string | undefined {
    Logger.trace(
      "checkMinMaxDatum",
      "feldName: " + feldName,
      "feldWert: " + feldWert,
      "minDatum: " + minDatum,
      "maxDatum: " + maxDatum,
      "required: " + required,
    );

    let fehlermeldung = undefined;

    if (feldWert == "" && required) {
      fehlermeldung = "Bitte geben Sie ein Datum ein.";
    } else if (feldWert) {
      const feldWertDate = dateStringToIsoDate(feldWert);
      const minDatumDate = dateStringToIsoDate(minDatum);
      const maxDatumDate = dateStringToIsoDate(maxDatum);
      if (!feldWertDate) {
        fehlermeldung = "Bitte geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein.";
      } else if (minDatumDate && maxDatumDate && (feldWertDate < minDatumDate || feldWertDate > maxDatumDate)) {
        fehlermeldung =
          "Bitte geben Sie ein Datum im Bereich vom " +
          dateStringToLocalDate(minDatum) +
          " bis zum " +
          dateStringToLocalDate(maxDatum) +
          " ein.";
      } else if (minDatumDate && feldWertDate < minDatumDate) {
        fehlermeldung = "Bitte geben Sie ein Datum ab dem " + dateStringToLocalDate(minDatum) + " ein.";
      } else if (maxDatumDate && feldWertDate > maxDatumDate) {
        fehlermeldung = "Bitte geben Sie ein Datum bis zum " + dateStringToLocalDate(maxDatum) + " ein.";
      }
    }
    if (fehlermeldung) {
      Logger.trace("     -> " + fehlermeldung);
    }
    return fehlermeldung;
  }

  function checkEmail(feldName: string, feldWert: string, required: boolean): string | undefined {
    Logger.trace("checkEmail", "feldName: " + feldName, "feldWert: " + feldWert, "required: " + required);

    let fehlermeldung = undefined;

    if (feldWert == "" && required) {
      fehlermeldung = "Bitte geben Sie eine E-Mail-Adresse ein.";
    } else if (feldWert && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(feldWert)) {
      fehlermeldung = "Bitte geben Sie eine gültige E-Mail-Adresse ein.";
    }

    if (fehlermeldung) {
      Logger.trace("     -> " + fehlermeldung);
    }
    return fehlermeldung;
  }

  function checkNummer(feldName: string, feldWert: string, required: boolean): string | undefined {
    Logger.trace("checkNummer", "feldName: " + feldName, "feldWert: " + feldWert, "required: " + required);

    let fehlermeldung = undefined;

    if (feldWert == "" && required) {
      fehlermeldung = "Bitte geben Sie einen Wert ein.";
    } else if (feldWert && !istInt(feldWert)) {
      fehlermeldung = "Bitte geben Sie einen numerischen Wert ein.";
    }

    if (fehlermeldung) {
      Logger.trace("     -> " + fehlermeldung);
    }
    return fehlermeldung;
  }

  function checkTelefonNummer(feldName: string, feldWert: string, required: boolean): string | undefined {
    Logger.trace("checkTelefonNummer", "feldName: " + feldName, "feldWert: " + feldWert, "required: " + required);

    const laengeFehler = checkMinMaxLaenge(feldName, feldWert, "0", "30", required);

    const musterFehler = (required || feldWert !== "") && !/^(0|\+49)([0-9 ])*$/.test(feldWert);

    return musterFehler || laengeFehler
      ? "Bitte geben Sie eine nationale Festnetz- oder Mobilnummer ohne Sonderzeichen ein (max. 30 Zeichen)."
      : undefined;
  }

  function checkMobilNummer(feldName: string, feldWert: string, required: boolean): string | undefined {
    Logger.trace("checkMobilNummer", "feldName: " + feldName, "feldWert: " + feldWert, "required: " + required);

    const laengeFehler = checkMinMaxLaenge(feldName, feldWert, "0", "30", required);

    const musterFehler = (required || feldWert !== "") && !/^(0 *1|\+49 *1)([0-9 ])*$/.test(feldWert);

    return musterFehler || laengeFehler
      ? "Bitte geben Sie eine gültige nationale Mobilnummer ohne Sonderzeichen ein (max. 30 Zeichen)."
      : undefined;
  }

  function checkIban(feldName: string, feldWert: string, required: boolean): string | undefined {
    Logger.trace("checkIban", "feldName: " + feldName, "feldWert: " + feldWert, "required: " + required);

    let fehlermeldung = undefined;

    if (feldWert == "" && required) {
      fehlermeldung = "Bitte geben Sie eine IBAN ein.";
    } else if (feldWert) {
      let hatFehler = false;
      let iban: string = feldWert.toUpperCase().replace(/\s/g, "");
      if (!iban.match(/^[\dA-Z]+$/)) {
        hatFehler = true;
      } else if (iban.length != 22) {
        hatFehler = true;
      } else {
        iban = iban.substr(4) + iban.substr(0, 4);
        let s: any;
        let m: any;
        let i: number;
        for (s = "", i = 0; i < iban.length; i += 1) {
          s += parseInt(iban.charAt(i), 36);
        }
        for (m = s.substr(0, 15) % 97, s = s.substr(15); s; s = s.substr(13)) {
          m = (m + s.substr(0, 13)) % 97;
        }
        if (m != 1) {
          hatFehler = true;
        }
      }
      if (hatFehler) {
        fehlermeldung = "Bitte geben Sie eine gültige IBAN ein.";
      } else if (!iban.match(/^[\dDE]+$/)) {
        fehlermeldung = "Bitte geben Sie eine deutsche IBAN ein.";
      }
    }

    if (fehlermeldung) {
      Logger.trace("     -> " + fehlermeldung);
    }
    return fehlermeldung;
  }

  function checkMinMaxAlter(
    feldName: string,
    geburtsdatum: string,
    berechnungsdatum: string,
    minAlter: number,
    maxAlter: number,
  ): string | undefined {
    Logger.trace(
      "checkMinMaxAlter",
      "feldName: " + feldName,
      "geburtsdatum: " + geburtsdatum,
      "berechnungsdatum: " + berechnungsdatum,
      "minAlter: " + minAlter,
      "maxAlter: " + maxAlter,
    );

    let fehlermeldung = undefined;

    if (!berechnungsdatum) {
      berechnungsdatum = getIsoDateNow();
    }
    const alter = getAlterZuStichtag(geburtsdatum, berechnungsdatum);
    if (alter !== undefined) {
      Logger.debug("     -> Errechnetes Alter zum " + berechnungsdatum + ": " + alter);
      if (alter < minAlter || alter > maxAlter) {
        fehlermeldung =
          "Das Alter der Person muss " +
          (berechnungsdatum ? "zum " + dateStringToLocalDate(berechnungsdatum) : "") +
          " zwischen " +
          minAlter +
          " und " +
          maxAlter +
          " Jahren liegen.";
      }
    }

    if (fehlermeldung) {
      Logger.trace("     -> " + fehlermeldung);
    }
    return fehlermeldung;
  }

  async function checkPlz(
    sessionId: string,
    feldName: string,
    feldWert: string,
    required: boolean,
  ): Promise<string | undefined> {
    Logger.trace("checkNummer", "feldName: " + feldName, "feldWert: " + feldWert, "required: " + required);

    let fehlermeldung = undefined;

    if (feldWert == "" && required) {
      fehlermeldung = "Bitte geben Sie einen Wert ein.";
    } else if (feldWert && !istInt(feldWert)) {
      fehlermeldung = "Bitte geben Sie einen numerischen Wert ein.";
    } else if (feldWert != "") {
      const data = await AdressenDatenService.plzValidieren(sessionId, feldWert);
      if (data === false) {
        fehlermeldung = "Bitte geben Sie eine gültige Postleitzahl ein.";
      }
    }
    if (fehlermeldung) {
      Logger.trace("     -> " + fehlermeldung);
    }
    return fehlermeldung;
  }

  return {
    checkMinMaxWert,
    checkMinMaxLaenge,
    checkMinMaxDatum,
    checkEmail,
    checkNummer,
    checkTelefonNummer,
    checkMobilNummer,
    checkMinMaxAlter,
    checkIban,
    checkPlz,
  };
}
